import { createContext, useContext } from 'react'
import type { HubSectionType } from './kit/types'

export interface HubAnalyticsCallbacks {
  onProductClick: (params: {
    productId: string
    productSlug: string
    productName: string
    outboundUrl: string
    price: number | null
    position: number
    sectionType: HubSectionType
  }) => void
  onReportClick: (params: {
    reportId: string
    reportSlug: string
    reportTitle: string
    position: number
  }) => void
}

const HubAnalyticsContext = createContext<HubAnalyticsCallbacks | null>(null)

export const HubAnalyticsProvider = HubAnalyticsContext.Provider

export function useHubAnalytics(): HubAnalyticsCallbacks | null {
  return useContext(HubAnalyticsContext)
}
